// extracted by mini-css-extract-plugin
export default {"container":"not-found_container__YtpY5","message":"not-found_message__92HEs","hyperlink":"not-found_hyperlink__8Gk59"};